import { ViewChild } from '@angular/core';
import { ElementRef } from '@angular/core';
import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { LevelOfDevelopment } from '@ascschool/model/school/level-of-development.model';
import { LevelOfDevelopmentService } from '@ascschool/services/school/level-of-development.service';
import { UtilsService } from '@ascschool/services/utils.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalRef } from 'ng-zorro-antd/modal';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { LevelOfDevelopmentTypesService } from '@ascschool/services/school/level-of-development-types.service';


@Component({
  selector: 'app-popup-muc-do-phat-trien',
  templateUrl: './popup-muc-do-phat-trien.component.html',
  styleUrls: ['./popup-muc-do-phat-trien.component.scss']
})
export class PopupMucDoPhatTrienComponent implements OnInit {
  validateForm = this.fb.group({
    id: [0],
    types: [null],
    code: [null, [Validators.required]],
    name: [null, [Validators.required]]
  });

  @Input() value: any;
  isEditMode = false;
  @ViewChild("form", { static: false }) formElement: ElementRef;
  errorMsg: string;
  isDisabled = false;
  typesControl = this.validateForm.controls.types;
  listLvSelect: number[] = [];
  levelOfDevelopment = new LevelOfDevelopment();
  listLv: ({
    id: number;
    name: string;
    checked: boolean;
  })[] = [];

  constructor(
    private modal: NzModalRef, private msg: NzMessageService, private service: LevelOfDevelopmentService,
    public utilsService: UtilsService, private fb: FormBuilder,
    private levelOfDevelopmentTypesService: LevelOfDevelopmentTypesService
  ) {
  }

  ngOnInit() {
    this.loadLevelOfDevelopmentType();
    if (this.value && this.value.id > 0) {
      this.GetById(this.value.id);
      this.isEditMode = true;
      this.levelOfDevelopment.id = this.value.id;
      this.validateForm = this.fb.group({
        id: this.value.id,
        name: [this.value.name, [Validators.required]],
        code: [this.value.code, [Validators.required]],
      });
    } else {
      this.levelOfDevelopment = new LevelOfDevelopment();
      this.isEditMode = false;
      this.validateForm = this.fb.group({
        name: [null, [Validators.required]],
        code: [null, [Validators.required]],
      });
    }

  }
  GetById(id: number) {
    this.service.getById(id).subscribe((res: any) => {
      this.levelOfDevelopment = res;
      this.listLvSelect = res.levelOfDevelopmentTypes;
    })
  }
  close() {
    this.destroyModal();
  }
  loadLevelOfDevelopmentType() {
    this.levelOfDevelopmentTypesService.getSelectPaging({ PageIndex: 1, PageSize: 100 }).subscribe(res => {
      this.listLv = res.results.map(x => ({ id: x.id, name: x.name, checked: false }));
    });
  }
  destroyModal(): void {
    this.modal.destroy(true);
  }
  UpdateClose() {
    if (this.listLvSelect.length < 1) {
      this.msg.error('Lĩnh vực: bắt buộc chọn');
      return;
    }
    if (this.validateForm.valid) {
      this.levelOfDevelopment = this.validateForm.value;
      // this.levelOfDevelopment.levelOfDevelopmentTypes = this.listLvSelect;
      // console.log(this.levelOfDevelopment);
      this.service.addOrUpdate({
        id: this.levelOfDevelopment.id, code: this.levelOfDevelopment.code, name: this.levelOfDevelopment.name, levelOfDevelopmentTypes: this.listLvSelect
      }).subscribe((res) => {
        if (res.statusCode === 0) {
          this.notification(res);
          this.close();
        } else {
          this.notification(res);
        }
      }, error => {
        this.msg.error('lỗi: ' + error.error.Message);
      });
    } else {
      this.utilsService.findInvalidControlsbyForm(this.validateForm, this.formElement);
    }
  }
  notification(response) {
    if (response.statusCode === 0) {
      this.msg.success('Cập nhật thông tin: ' + response.message);
    } else {
      this.msg.error('Lỗi: ' + response.message);
    }
  }
}
